import ACCOUNT_CLIENT_API_ENDPOINTS from '@api/endpoints';
import HTTP_METHODS_ENUM from '@api/enums/HTTP_METHODS_ENUM.enum';
import configRequest from '@api/requests/configRequest';

import { showToast } from '@app/providers/ToastProvider';

export interface VerifyPhoneData {
	phone_change_code: string;
	email: string;
	phone: string;
	branch: number;
	first_name: string;
	last_name: string;
	mfa_enabled: boolean;
}

export type VerifyPhoneResponse = void;

const verifyPhone = configRequest<VerifyPhoneResponse, VerifyPhoneData>({
	requestPrefix: 'auth/verifyPhone',
	reqConfigCreator: data => ({
		url: ACCOUNT_CLIENT_API_ENDPOINTS.AUTH.VERIFICATION.PHONE.VERIFY(),
		method: HTTP_METHODS_ENUM.PUT,
		data,
		headers: { branch: data?.branch || 0 },
	}),
	onSuccess: () => showToast.success('Your phone number has been successfully verified.'),
});

export default verifyPhone;
